import * as React from 'react';
import EkonomiskAnalysChartQuery, {
  IAnalysChart,
  ChartActions,
  IDrilldown,
  ChartType,
} from '../../../../Delsystem/Ekonomi/Rutiner/EkonomiskAnalys/Queries/EkonomiskAnalysChartQuery/EkonomiskAnalysChartQuery';
import { DrilldownEventObject, SeriesClickEventObject } from 'highcharts';
import { IEkonomiskAnalysCardSettings } from '../../../../Delsystem/Ekonomi/Rutiner/EkonomiskAnalys/Components/EkonomiskAnalysMain/EkonomiskAnalysMain';
import GraphCard from '../GraphCard/GraphCard';
import GraphPanel from '../GraphPanel/GraphPanel';
import { IEkonomiskAnalysFilledDates } from '../../../../Delsystem/Ekonomi/Rutiner/EkonomiskAnalys/Components/AnalysSettingsHandler/AnalysSettingsHandler';
import { ActiveDatabaseConsumer } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import { Navigate } from 'react-router';

interface IProps {
  type: ChartType;
}

interface IState {
  redirectState: IEkonomiskAnalysCardSettings | null;
}

interface IFakeQuery {
  id: string;
  kodbehorighetId: string;
  grundurvalId: string;
  grafColumns?: number[];
  dates: IEkonomiskAnalysFilledDates;
  type: ChartType;
}

class EkonomiskAnalysCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      redirectState: null,
    };
  }

  onDrilldown =
    (
      kodbehorighetId: string,
      analysId: string,
      dates: IEkonomiskAnalysFilledDates
    ) =>
    (event: DrilldownEventObject | SeriesClickEventObject) => {
      if (event.point) {
        const drilldown: IDrilldown = JSON.parse(
          (event.point as any).drilldown
        );
        const actionType = drilldown.actionType;

        if (actionType === ChartActions.EkonomiskAnalys) {
          this.setState({
            redirectState: {
              kodbehorighetId: kodbehorighetId,
              analysId: analysId,
              dates: dates,
              params: drilldown.params,
            },
          });
        }
      }
    };

  getFakeQuery = (): IFakeQuery => {
    switch (this.props.type) {
      case 'column':
        return {
          id: 'sZebmlCUurbriHSjjGHGAGfjkoozyJEHENNAFBTiHHV',
          kodbehorighetId: 'yuUmiHpjbZmZxhBkkfhfIdDNnZMkdUjiTToxfroxH',
          grundurvalId: 'geGjkxmfUMjMzOVooJOJKnCDuMIonGfshJoOrzNNx',
          grafColumns: [],
          dates: {
            from: {
              year: 2018,
              month: 5,
              day: 1,
            },
            to: {
              year: 2018,
              month: 5,
              day: 1,
            },
          },
          type: 'column',
        };
      case 'pie':
        return {
          id: 'MmkxOgHzibxbcAYNNdAdGdDNFvvSeCUAUBBGLrnncME',
          kodbehorighetId: 'yuUmiHpjbZmZxhBkkfhfIdDNnZMkdUjiTToxfroxH',
          grundurvalId: 'ulxhgEsOHphpAMJccNMNjSBKPpmcSxgAncZuDAId',
          grafColumns: [1],
          dates: {
            from: {
              year: 2018,
              month: 11,
              day: 1,
            },
            to: {
              year: 2018,
              month: 11,
              day: 1,
            },
          },
          type: 'pie',
        };
      case 'bubble':
        return {
          id: 'sZebmlCUurbriHSjjGHGAGfjkoozyJEHENNAFBTiHHV',
          kodbehorighetId: 'yuUmiHpjbZmZxhBkkfhfIdDNnZMkdUjiTToxfroxH',
          grundurvalId: 'geGjkxmfUMjMzOVooJOJKnCDuMIonGfshJoOrzNNx',
          grafColumns: [],
          dates: {
            from: {
              year: 2018,
              month: 5,
              day: 1,
            },
            to: {
              year: 2018,
              month: 5,
              day: 1,
            },
          },
          type: 'bubble',
        };
      case 'line':
        return {
          id: 'sZebmlCUurbriHSjjGHGAGfjkoozyJEHENNAFBTiHHV',
          kodbehorighetId: 'yuUmiHpjbZmZxhBkkfhfIdDNnZMkdUjiTToxfroxH',
          grundurvalId: 'geGjkxmfUMjMzOVooJOJKnCDuMIonGfshJoOrzNNx',
          grafColumns: [],
          dates: {
            from: {
              year: 2018,
              month: 5,
              day: 1,
            },
            to: {
              year: 2018,
              month: 5,
              day: 1,
            },
          },
          type: 'column',
        };
    }
  };

  render() {
    const query: IFakeQuery = this.getFakeQuery();
    return (
      <ActiveDatabaseConsumer>
        {({ activeDatabase }) => (
          <>
            {activeDatabase === 'Almstena församling' && (
              <>
                {this.state.redirectState && (
                  <Navigate
                    to={{
                      pathname: `/${activeDatabase}/Rutin/EkonomiskAnalys`,
                    }}
                    state={{
                      ekonomiskAnalysSettings: this.state.redirectState,
                    }}
                  />
                )}
                <EkonomiskAnalysChartQuery
                  id={query.id}
                  kodbehorighetId={query.kodbehorighetId}
                  grundurvalId={query.grundurvalId}
                  grafColumns={query.grafColumns}
                  dates={query.dates}
                  type={query.type}
                  loadingComponent={<GraphPanel type={this.props.type} />}
                  useDrilldown
                >
                  {(analys: IAnalysChart) => (
                    <GraphCard
                      analys={analys}
                      title={`${analys.title}`}
                      link={`${activeDatabase}/Rutin/EkonomiskAnalys?kid=${
                        query.kodbehorighetId
                      }&id=${query.id}&fromYear=${
                        query.dates.from.year || ''
                      }&fromMonth=${query.dates.from.month || ''}&fromDay=${
                        query.dates.from.day || ''
                      }&toYear=${query.dates.to.year || ''}&toMonth=${
                        query.dates.to.month || ''
                      }&toDay=${query.dates.to.day || ''}`}
                      type={this.props.type}
                      onDrilldown={this.onDrilldown(
                        query.kodbehorighetId,
                        query.id,
                        query.dates
                      )}
                    />
                  )}
                </EkonomiskAnalysChartQuery>
              </>
            )}
          </>
        )}
      </ActiveDatabaseConsumer>
    );
  }
}

export default EkonomiskAnalysCard;
